/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import { string, bool, func, number } from "prop-types";
import InputText from "../InputText/InputText";

const inRange = function (num, start, end) {
  // If no end number, use start as end
  if (!end) {
    end = start;
    start = 0;
  }
  return num >= start && num <= end;
};

class InputNumeric extends React.Component {
  constructor(props) {
    super(props);
    this.checkInputValidity = this.checkInputValidity.bind(this);
    this.fieldChanged = this.fieldChanged.bind(this);
    this.focused = this.focused.bind(this);
  }

  checkInputValidity(event) {
    const MIN_EXCLUDE_KEYCODE_MARGIN_VALUE = 58;
    const MAX_EXCLUDE_KEYCODE_MARGIN_VALUE = 222;
    const MIN_NUMPAD_KEYCODE_VALUE = 96;
    const MAX_NUMPAD_KEYCODE_VALUE = 105;
    const DECIMAL_POINT_KEYCODE_VALUES = [110, 190];
    const charCode = event.which || event.keyCode;
    // reject all non numeric charactors as input expect control keys and decimal point
    if (
      inRange(
        charCode,
        MIN_EXCLUDE_KEYCODE_MARGIN_VALUE,
        MIN_NUMPAD_KEYCODE_VALUE
      ) &&
      !inRange(
        charCode,
        MAX_NUMPAD_KEYCODE_VALUE + 1,
        MAX_EXCLUDE_KEYCODE_MARGIN_VALUE + 1
      ) &&
      !DECIMAL_POINT_KEYCODE_VALUES.includes(charCode)
    ) {
      console.log("Bad ... " + charCode);
      event.preventDefault();
    } else {
      console.log(charCode);
    }
  }

  fieldChanged(element) {
    // TODO review. This was commented since there's no any use seen of this empty blocks.
    // if (element.value === '' || /^\d{1,2}(?:[.]\d{0,1})?$/.test(element.value) ||
    //   /^[.]\d{0,1}?$/.test(element.value)) {
    // } else {
    // }
  }

  focused(element) {
    element.selectionStart = element.selectionEnd = element.value.length;
  }

  componentDidMount() {
    document.addEventListener("handleKeyDown", this.checkInputValidity, false);
  }

  componentWillUnmount() {
    document.removeEventListener(
      "handleKeyDown",
      this.checkInputValidity,
      false
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        <InputText
          {...this.props}
          ariaDescription="Allow only a number with one decimal point."
          handleKeyDown={this.checkInputValidity}
          handleChange={(event) => this.fieldChanged(event.target)}
          handleFocus={(event) => this.focused(event.target)}
        />
      </div>
    );
  }
}

InputNumeric.propTypes = {
  id: string.isRequired,
  title: string.isRequired,
  value: number.isRequired,
  placeholder: string.isRequired,
  required: bool,
  className: string,
  disabled: bool,
  handleKeyDown: func,
  handleChange: func,
  handleFocus: func,
};

InputNumeric.defaultProps = {
  disabled: false,
  required: false,
  handleKeyDown: () => void 0,
  handleChange: () => void 0,
  handleFocus: () => void 0,
};

export default InputNumeric;
